// src/store/modules/layout.js
const state = {
  isToggleSidebar: true
};

const mutations = {
  SET_TOGGLE_SIDEBAR(state, payload) {
    state.isToggleSidebar = payload;
  }
};

const actions = {
  toggleSidebar({ commit }, payload) {
    commit('SET_TOGGLE_SIDEBAR', payload);
  }
};

const getters = {
  isToggleSidebar: (state) => state.isToggleSidebar
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
